import { lazy } from "react";
import { RouteConfig } from "../../../../types/RouteConfig";

export const applyForConnectOpportunityRoute: RouteConfig<'with-page'> = {
    name: 'Apply for Connect Opportunity',
    path: '/work-opps/apply/:workOppId',
    context: 'member',
    page: lazy(() => import('.')),
    flags: ['member-route'],
}